export const dateFormat1 = 'DD/MMM/YYYY'

export const dateFormat2  = "YYYY-MM-DD"

export const dateFormat3 = 'DD/MMM/YYYY'

export const apiErrorText = ['error','failed']

export const SIPaymentTypes=["card","upi","enach","bankaccount","bankAccount","eNach","UPI"];
export const ChequePaymentTypes=["cheque"];